module.exports = __webpack_public_path__ + "img/img_side_rainbow.3fe6fe5e.png";